exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-94875de4]{font-size:44px;line-height:normal}.btn-gray[data-v-94875de4],.btn-purple[data-v-94875de4]{padding:12px 45px;margin-top:30px}.btn-gray[data-v-94875de4]{margin-left:30px}.main-line-3[data-v-94875de4]{position:absolute;bottom:0;right:200px}@media screen and (max-width:900px){h2[data-v-94875de4]{font-size:32px;line-height:1.36}}@media screen and (max-width:767px){.slide-content[data-v-94875de4]{margin-top:0}h2[data-v-94875de4]{font-size:28px;line-height:1.36}.btn-gray[data-v-94875de4],.btn-purple[data-v-94875de4]{display:block;width:100%;margin:20px 0}.btn-purple[data-v-94875de4]{margin-top:50px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-94875de4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Slide6.vue
// module id = 414
// module chunks = 0